module.exports = __webpack_public_path__ + "img/big-spaceman.e9a9582b.png";